module.exports = __webpack_public_path__ + "img/bt_er.cd38a912.png";